export function PLANO(state) {
  return state.nome_plano;
}

export function VALOR_INCREMENTAVEL(state) {
  if (state.nome_plano == "Flex Familia") {
    return false;
  } else if (state.nome_plano == "Flex Familia Rio") {
    return false;
  } else if (state.nome_plano == "Flex Familia Top") {
    return false;
  } else if (state.nome_plano == "Flex Corp") {
    return true;
  } else if (state.nome_plano == "Flex Multi") {
    return true;
  } else if (state.nome_plano == "Flex Multi Top") {
    return true;
  } else {
    null;
  }
}

export function VALOR_MENSAL(state, getters, rootState) {
  return rootState.products.produtos.find(
    p => p.nome_plano == state.nome_plano
  ).valor;
}

export function CONTRATANTE_ASSOCIADO(state) {
  if (state.nome_plano == "Flex Familia") {
    return true;
  } else if (state.nome_plano == "Flex Familia Rio") {
    return true;
  } else if (state.nome_plano == "Flex Familia Top") {
    return true;
  } else {
    return false;
  }
}

export function CONTRATANTE_TEM_QUE_SER_ASSOCIADO(state) {
  if (state.nome_plano == "Flex Familia") {
    return true;
  } else if (state.nome_plano == "Flex Familia Rio") {
    return true;
  } else if (state.nome_plano == "Flex Familia Top") {
    return true;
  } else {
    return false;
  }
}

export function ASSOCIADOS_LIMITE(state) {
  if (state.nome_plano == "Flex Familia") {
    return 4;
  } else if (state.nome_plano == "Flex Familia Rio") {
    return 4;
  } else if (state.nome_plano == "Flex Familia Top") {
    return 4;
  } else if (state.nome_plano == "Flex Corp") {
    return 200;
  } else {
    return 20;
  }
}

export function DADOS_INTERNOS(state) {
  return {
    id_vendedor: state.id_vendedor,
    id_produto: state.id_produto,
    id_plano: state.id_plano,
    id_unidade: state.id_unidade,
    nome_unidade: state.nome_unidade,
    nome_vendedor: state.nome_vendedor,
    nome_produto: state.nome_produto,
    nome_plano: state.nome_plano
  };
}
